export default __webpack_public_path__ + "static/media/partyGIF.152a3c27.gif";